<template>
  <div class="box" :class="bgClass">
    <template v-if="!loading">
      <div class="tips-box" v-if="delay == 1 && from == 2 && isShowDelay">
        <span class="icon"></span>
        <span class="text">{{market == 'HK' ? $t("treemap.t0") : $t("treemap.t1")}}{{ $t("treemap.t2") }}</span>
        <span class="close" @click="closeTips">
        <Icon name="cross" />
      </span>
      </div>
      <div class="treemap" id="treemap" :class="{style2: from == 2}">

      </div>
      <div class="source" v-if="from == 2">{{source}}</div>
    </template>
    <template v-if="loading">
      <div class="loading">
        <Loading size="20px" type="spinner"  />
        <span class="text">{{ $t("common.loading_text") }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { Icon, Loading } from "vant";
import { jumpLink } from "@/utils/hybirdMethods";
export default {
  name: "treeMap",
  components: {Icon,Loading},
  computed:{
    bgClass(){
      return this.$store.getters["common/bgColor"];
    },

  },
  data(){
    return {
      from: 1,
      delay: 0,
      source: "",
      market: "",
      isShowDelay: true,
      loading: true,
    }
  },
  mounted() {
    this.delay = this.$route.query.delay;
    this.from = this.$route.query.from; // 1 行情  2热力图详情
    this.market =  this.$route.query.market || 'HK';
    if(this.$route.query.deviceNo){
      sessionStorage.setItem("device_no", this.$route.query.deviceNo);
    }
    this.getQueryIndexAll();
    this.quoteQueryMarketPackage();
  },
  methods: {
    closeTips(){
      this.isShowDelay = false;
      this.$nextTick(() => {
        if (this.myChart) {
          this.myChart.resize();
        }
      });
    },
    quoteQueryMarketPackage(){
      this.$apis.quoteQueryMarketPackageApi().then(res => {
        this.source = res.data.source
      })
    },
    getQueryIndexAll(){
      this.$apis.getQueryIndexAllApi({
        market: this.market,
        sort: 2
      }).then(res => {
        this.loading = false;
        if(res && res.data && res.data.data && res.data.data.length > 0){
          this.listData = this.from == 1 ? res.data.data.slice(0, 8) : res.data.data;
          this.$nextTick(()=>{
            this.initChart(true)
          })
        }
      }).catch(()=>{
        clearTimeout(this.timer)
        this.timer = setTimeout(()=>{
          const second = new Date().getSeconds();
          if(second % 2 == 0){
            this.getQueryIndexAll();
          }else{
            this.initChart(false);
          }
        },1000);
      })
    },
    getAvgValue () {
      const { length } = this.listData;
      const count = this.listData.reduce((a,b)=> a + Math.abs(b.change_ratio), 0)
      return count / length;
    },
    setColor(num){
      const type = this.$route.query.color || 1;  // 红涨绿地跌 2绿涨红跌
      if(type != 1){
        num = num * -1;
      }
      const colors = [
        {
          area: [1.2, 100],
          color: 'rgba(238,58,83,0.50)'
        },
        {
          area: [0.4, 1.2],
          color: 'rgba(238,58,83,0.30)'
        },
        {
          area: [0, 0.4],
          color: 'rgba(238,58,83,0.15)'
        },
        {
          area: [0, 0],
          color: '#D1D1D1'
        },
        {
          area: [-0.4, 0],
          color: 'rgba(1,167,111,0.15)'
        },
        {
          area: [-1.2, -0.4],
          color: 'rgba(1,167,111,0.3)'
        },
        {
          area: [-100, -1.2],
          color: 'rgba(1,167,111,0.5)'
        }
      ];
      let _index = colors.findIndex(
        item => ((num > item.area[0] && num <= item.area[1]) || (num == item.area[0] && num == item.area[1]))
      );
      if(_index < 0){
        _index = num > 0 ? 0 : colors.length - 1;
      }
      const { color } = colors[_index]
      return color;
    },
    async initChart(reset = true){
      if(reset){
        const echarts = await import('echarts/lib/echarts');
        await import('echarts/lib/chart/treemap');

        const chartDom = document.getElementById('treemap');
        this.myChart = echarts.init(chartDom);
        const data = this.listData.map(item => {
          const display_change_ratio = item.change_ratio > 0 ? '+' + item.display_change_ratio : item.display_change_ratio;
          const i = {
            name: item.index_name + '\n' + display_change_ratio,
            value: Math.max(item.change_ratio == 0 ? this.getAvgValue() : Math.abs(item.change_ratio), 0.2),// 强制显示文本处理
            custom: item.display_change_ratio,
            toAppData: JSON.stringify({ ...item, market: this.market }),
            itemStyle: {
              color: this.setColor(item.change_ratio),
              borderRadius: 8
            }
          };
          return i;
        })
        const backgroundColor = this.bgClass == "black-theme" ? "#1B1C24" : "#fff";
        const option = {
          backgroundColor,
          series: [
            {
              type: 'treemap',
              layoutAlgorithm: 'slice',
              // 设置节点间距
              nodePadding: 5,
              squareRatio: 1,
              roam: false,
              nodeClick: false,
              width: '100%',
              height: '100%',
              animation: false,
              breadcrumb: {
                show: false
              },
              levels: [{
                itemStyle: {
                  borderWidth: 2,
                  borderColor: backgroundColor,
                  gapWidth: 4
                },
              }],
              data,
              label: {
                position: [0, '50%'],
                offset: [0, -20],
                show: true,
                // 定义富文本样式
                rich: {
                  mt: {
                    lineHeight: 5
                  },
                  title: {
                    fontSize: 11,
                    color: "#000"
                  },
                  red:{
                    color: '#EE3A53'
                  },
                  green: {
                    color: '#01A76F'
                  },
                  lh: {
                    lineHeight: 3
                  }
                },
                formatter:  (params) => {
                  const vals = params.name.split("\n");
                  if (!vals[1]) {
                    return "{title|" + vals[0] + "}";
                  }
                  let color = vals[1].indexOf("-") < 0 ? "{red|" : "{green|";
                  if(this.$route.query.color == 2){
                    color = vals[1].indexOf("-") < 0 ? "{green|" : "{red|";
                  }
                  return "{lh|}\n" + "{title|" + vals[0] + '} \n' + "{lh|}\n" + color  + vals[1] + '}';
                }
              }
            }
          ]
        };
        option && this.myChart.setOption(option);
        if(this.myChart){
          this.myChart.off('click', this.toDetail);
          this.myChart.on('click', this.toDetail);

        }
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(()=>{
        const second = new Date().getSeconds();
        if(second % 2 == 0){
          this.getQueryIndexAll();
        }else{
          this.initChart(false);
        }
      },1000);
    },
    toDetail(e){
      if (e.data?.toAppData !== undefined) {
        jumpLink({
          url: "ConstituentMarket",
          data: e.data.toAppData
        })
      }
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped lang="less">
.box{
  height: 100%;
  display: flex;
  flex-direction: column;
  .treemap{
    flex: 1;
    &.style2{
      margin: 10px 16px 0;
    }
  }
  .tips-box{
    background: #FFF9EF;
    height: 60px;
    line-height: 60px;
    color: #17161C;
    font-size: 28px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    .icon{
      height: 60px;
      width: 60px;
      background: url("../../assets/images/delay-icon.png") no-repeat center;
      background-size: 45px 45px;
    }
    .text{
      flex: 1;
      margin-top: 5px;
      line-height: 65px;
    }
    .close{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      width: 60px;
    }
  }
  .source{
    text-align: center;
    margin: 20px 0;
    padding-bottom: 50px;
    color: #444;
    font-size: 24px;
  }
  &.black-theme{
    .source{
      color: rgba(255,255,255,0.4);
    }
  }
  .loading{
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #c9c9c9;
    .text{
      margin-left: 10px;
    }
  }
}
</style>
